










































































































import type { PagamentoServiceAdapter } from '@/usecases'
import { Inject } from 'inversify-props'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { imprimirComprovanteSitef } from '@/shareds/impressao-comprovente-de-cancelamento-do-pagamento';


	interface MenuAdministrativoSitef {
	id: string
	titulo: string
	mensagem: string
	command: number
	status: string
	retorno: string
	}

	interface OpcaoSitef {
	id: number
	descricao: string
	}

	type Modo = 'vazio' | 'menu' | 'confirm' | 'input' | 'recibo'

function ehListaDeOpcoes(msg?: string): boolean {
	if (!msg) return false
	return /(?:^|;)\s*\d+\s*:\s*[^;]+/.test(msg)
}

@Component
export default class DialogoMenuAdministrativoSitef extends Vue {
	@Prop({ type: Boolean}) telaDeCaixa!: boolean
	mostra = false
	carregando = false
	transacaoId: string | null = null
	commandId: number | null = null
	titulo = ''
	mensagem = ''
	opcoesString = ''
	numeric = false
	maxLength = 0
	minLength = 0
	labelInput = 'Digite o valor'

	opcoes: OpcaoSitef[] = []
	valorInput = ''
	menuAdministrativoId = ''
	pontoDeVendaId = ''
	passwordField = false
	mostrarSenha = false

	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter
	
	mostrar(menu: MenuAdministrativoSitef, transacaoId: string, pontoDeVendaId: string) {
		this.pontoDeVendaId = pontoDeVendaId
		this.transacaoId = transacaoId
		this.menuAdministrativoId = menu.id
		this._aplicarMenu(menu)
		this.mostra = true
		this.$nextTick(() => {
			if (this.modo === 'input') (this.$refs.campo as any)?.focus?.()
		})
	}

	atualizar(menu: MenuAdministrativoSitef, pontoDeVendaId: string) {
		this.pontoDeVendaId = pontoDeVendaId
		this.menuAdministrativoId = menu.id
		this.mensagem = menu.mensagem
		this._aplicarMenu(menu)
		this.$nextTick(() => {
			if (this.modo === 'input') (this.$refs.campo as any)?.focus?.()
		})
	}

	private _aplicarMenu(menu: MenuAdministrativoSitef) {
		this.commandId = menu.command ?? null
		this.titulo    = menu.titulo   ?? ''
		this.mensagem  = menu.mensagem ?? ''

		this.opcoesString = ehListaDeOpcoes(this.mensagem) ? this.mensagem : ''
		this.opcoes = this.processarOpcoes(this.opcoesString)
		const msgNorm = DialogoMenuAdministrativoSitef.normalizar(this.mensagem)
		const alvoNorm = DialogoMenuAdministrativoSitef.normalizar('Forneça o código do supervisor')
		this.passwordField = (msgNorm === alvoNorm)
		this.mostrarSenha = false
		this.valorInput = ''
	}

	get modo(): Modo {
		if (this.opcoes.length > 0) {return 'menu'}
		if (this.commandId === 20) return 'confirm' // Sim/Não
		if (this.ehComandoDeInput(this.commandId)) return 'input'   // Input
		if (this.commandId === 0) return 'recibo' // Sim/Não

		return 'vazio'
	}

	get rules() {
		const r: Array<(v: string) => true | string> = []
		if (this.minLength > 0) {
			r.push(v => (v && v.length >= this.minLength) || `Mínimo de ${this.minLength} caracteres`)
		}
		if (this.maxLength > 0) {
			r.push(v => (v && v.length <= this.maxLength) || `Máximo de ${this.maxLength} caracteres`)
		}
		if (this.numeric) {
			r.push(v => (/^\d+$/.test(v) || v === '') || 'Apenas números')
		}
		return r
	}

	fechar() {
		this.$emit('cancelar', this.transacaoId) 
		this.mostra = false
	}

	ehComandoDeInput(cmd: number | null): boolean {
		return !!cmd && [21, 30, 31, 32, 33, 34, 35, 38].includes(cmd)
	}

	async responder(retorno: string) {
		this.pagamentoService.salvarRetornoNoMenuAdministrativoSitef(this.menuAdministrativoId, retorno)
		if (this.telaDeCaixa){
			if (retorno === "1") {
				await this.pagamentoService.cancelarTransacaoSitefAtual(this.pontoDeVendaId, false)
			}
			this.mostra = false
		}
	}

	confirmarInput() {
		if (this.minLength > 0 && this.valorInput.length < this.minLength) return
		if (this.maxLength > 0 && this.valorInput.length > this.maxLength) return
		if (this.numeric && this.valorInput && !/^\d+$/.test(this.valorInput)) return
		this.responder(this.valorInput || '')
	}

	processarOpcoes(opcoesStr: string): OpcaoSitef[] {
		if (!opcoesStr || !opcoesStr.trim()) return []
		return opcoesStr.split(';')
			.map(parte => {
				const [idStr, ...rest] = parte.split(':')
				const id = parseInt((idStr || '').trim(), 10)
				const descricao = (rest.join(':') || '').trim()
				if (Number.isFinite(id) && descricao) return { id, descricao }
				return null
			})
			.filter(Boolean) as OpcaoSitef[]
	}

	async imprimirRecibo(){
		await imprimirComprovanteSitef([this.mensagem, this.mensagem])
		this.pagamentoService.salvarRetornoNoMenuAdministrativoSitef(this.menuAdministrativoId, "impresso")
		this.fechar()
	}

	private static normalizar(s?: string) {
		return (s || '')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.trim()
	}
	

}
